import { frontendURL } from '../../../helper/URLHelper';

const Index = () => import('./Index.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/care-alerts'),
    name: 'care_alerts_index',
    meta: { permissions: ['administrator', 'agent'] },
    component: Index,
  },
];
